module.exports = __webpack_public_path__ + "static/media/chevromRight.44aa140a.svg";